<template>
  <v-container
    fluid
    tag="section"
  >
    <v-row>
      <v-col
        cols="12"
      >
        <div
          class="font-weight-medium ml-5"
          style="font-size: 20px"
        >
          Investor Positioning
        </div>
      </v-col>
    </v-row>
    
    <v-card class="mt-5">
      <v-container fluid class="pa-5">
        <v-btn
          color="primary"
          outlined
          class="mr-0"
          @click="selectInvestorDialog = true"
        >
          Select investor
        </v-btn>
      </v-container>
    </v-card>

    <v-card class="mt-5">
      <v-container fluid class="pa-5">
        <p>Filter Closest Investor</p>
        <v-row>
          <v-col cols="12" md="4">
            <v-select
              v-model="type"
              :items="states"
              label="Type"
              multiple
              chips
            ></v-select>
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="country"
              :items="states"
              label="Country"
              multiple
              chips
            ></v-select>
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="style"
              label="Style"
              :items="states"
              multiple
              chips
            ></v-select>
          </v-col>
          <v-col
            cols="12"
            class="text-right"
          >
            <v-btn
              color="primary"
              outlined
              class="mr-3"
            >
              Apply
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-container fluid>
      <v-row>
        <v-col cols="12" md="8">
          <v-img
            :src="require('@/assets/dashboard-res.jpg')"
          >
          </v-img>
        </v-col>
        <v-col cols="12" md="4">
          <v-row>
            <v-col cols="12" style="border: 1px solid #00bfc5;">
              <v-container>
                <p class="font-weight-bold" style="font-size: 20px;">Investor Name</p>
                <v-simple-table>
                  <tbody>
                    <tr>
                      <td style="font-size: 18px; font-weight: 300;">Style<v-icon class="ml-3" color="primary">mdi-alert-circle-outline</v-icon></td>
                      <td><span class="font-weight-bold" style="font-size: 18px;">Value Investor</span></td>
                    </tr>
                    <tr>
                      <td style="font-size: 18px; font-weight: 300;">AUM<v-icon class="ml-3" color="primary">mdi-alert-circle-outline</v-icon></td>
                      <td><span class="font-weight-bold" style="font-size: 18px;">$ 1.3M</span></td>
                    </tr>
                    <tr>
                      <td style="font-size: 18px; font-weight: 300;">Country</td>
                      <td><span class="font-weight-bold" style="font-size: 18px;">USA</span></td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-container>
            </v-col>
            <v-col cols="12" style="border: 1px solid #00bfc5; border-top: 0px;">
              <v-container>
                <p class="font-weight-bold" style="font-size: 20px;">Similar</p>
                <v-row>
                  <v-col md="6" class="text-center">
                    <v-avatar
                      size="150"
                      style="background: linear-gradient(to bottom, #3a98ed, #2ca9cd);"
                    >
                      Portfolio Name
                    </v-avatar>
                  </v-col>
                  <v-col md="6" class="text-center">
                    <v-avatar
                      size="150"
                      style="background: linear-gradient(to bottom, #3a98ed, #2ca9cd);"
                    >
                      Portfolio Name
                    </v-avatar>
                  </v-col>
                  <v-col md="6" class="text-center">
                    <v-avatar
                      size="150"
                      style="background: linear-gradient(to bottom, #3a98ed, #2ca9cd);"
                    >
                      Portfolio Name
                    </v-avatar>
                  </v-col>
                  <v-col md="6" class="text-center">
                    <v-avatar
                      size="150"
                      style="background: linear-gradient(to bottom, #3a98ed, #2ca9cd);"
                    >
                      Portfolio Name
                    </v-avatar>
                  </v-col>
                  <v-col md="6" class="text-center">
                    <v-avatar
                      size="150"
                      style="background: linear-gradient(to bottom, #3a98ed, #2ca9cd);"
                    >
                      Portfolio Name
                    </v-avatar>
                  </v-col>
                  <v-col md="6" class="text-center">
                    <v-avatar
                      size="150"
                      style="background: linear-gradient(to bottom, #3a98ed, #2ca9cd);"
                    >
                      Portfolio Name
                    </v-avatar>
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    
    <v-dialog v-model="selectInvestorDialog" persistent max-width="600px">
      <v-card class="px-3" style="background: #121212;">
        <v-container>
          <v-row>
            <v-col cols="12" md="9">
              <v-text-field
                v-model="searchInvestor"
                label="Search by Name, RIC or Ticker"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-btn
                color="primary"
                class="mr-3"
              >
                Search
              </v-btn>
            </v-col>
            <v-col cols="12">
              <v-data-table
                :headers="investorHeaders"
                :items="investorItems"
                :search.sync="searchInvestor"
                :mobile-breakpoint="0"
              >
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="selectInvestorDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  export default {
    name: 'investorPositioning',
    data() {
      return {
        type: [],
        country: [],
        style: [],
        states: [
          'Alabama', 'Alaska', 'American Samoa', 'Arizona',
          'Arkansas', 'California', 'Colorado', 'Connecticut',
          'Delaware', 'District of Columbia', 'Federated States of Micronesia',
          'Florida', 'Georgia', 'Guam', 'Hawaii', 'Idaho',
          'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky',
          'Louisiana', 'Maine', 'Marshall Islands', 'Maryland',
          'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi',
          'Missouri', 'Montana', 'Nebraska', 'Nevada',
          'New Hampshire', 'New Jersey', 'New Mexico', 'New York',
          'North Carolina', 'North Dakota', 'Northern Mariana Islands', 'Ohio',
          'Oklahoma', 'Oregon', 'Palau', 'Pennsylvania', 'Puerto Rico',
          'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee',
          'Texas', 'Utah', 'Vermont', 'Virgin Island', 'Virginia',
          'Washington', 'West Virginia', 'Wisconsin', 'Wyoming',
        ],
        selectInvestorDialog: false,
        searchInvestor: '',
        investorHeaders: [
          { text: 'Investor Name', value: 'name' },
          { text: 'Type', value: 'type' },
        ],
        investorItems: [
          {
            id: '1',
            name: 'Matthews International Capital Management',
            type: 'ETF',
          },
        ],
      }
    },
    computed: {
      browseButtonText () {
        return this.selectedFile ? this.selectedFile.name : 'Browse'
      }
    },
  }
</script>
